import { render, staticRenderFns } from "./sub_card.vue?vue&type=template&id=50dc6c70&"
import script from "./sub_card.vue?vue&type=script&lang=js&"
export * from "./sub_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports